import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApplicationLogo as getApplicationLogoApi } from "../../helpers/api_helper";

export const getApplicationLogo = createAsyncThunk("logo/getApplicationLogo", async (tenantId) => {
    try {
        const response = await getApplicationLogoApi(tenantId);
        return response.logo;
    } catch (error) {
        console.error("Error fetching logo:", error);
        return error;
    }
});